const digest = '77ca4fb54ff03a8d319ff81a9a0c96fc70f554ee3207b1957d4aa8218031bd7c';
const css = `._collapseCaret_1j23j_1>span:first-child{color:#fff!important;fill:#fff!important}._noVerticalPadding_1j23j_6>div{padding:0!important}._iconContainer_1j23j_10{border-radius:100rem;padding:6px 8px 7px}@media screen and (max-width:1023px){._iconContainer_1j23j_10{padding:6px 3px 7px}._iconSize_1j23j_21>svg{height:1.5em;margin-bottom:.25em;margin-top:.25em;width:1.5em}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'collapseCaret': '_collapseCaret_1j23j_1', 'noVerticalPadding': '_noVerticalPadding_1j23j_6', 'iconContainer': '_iconContainer_1j23j_10', 'iconSize': '_iconSize_1j23j_21' };
export const collapseCaret = '_collapseCaret_1j23j_1';
export const noVerticalPadding = '_noVerticalPadding_1j23j_6';
export const iconContainer = '_iconContainer_1j23j_10';
export const iconSize = '_iconSize_1j23j_21';
export { css, digest };